import { nanoid } from 'nanoid';

const LAYERS_CLEANUP_RETRY_TIMEOUT = 50;
export const removeLayersWhenMapReady = (map, layersToRemoveIds: string[]) => {
  (function cleanup() {
    if (!map.loaded()) {
      setTimeout(cleanup, LAYERS_CLEANUP_RETRY_TIMEOUT);
      return;
    }

    const styleLayerIds = map.getStyle().layers.map(({ id }) => id);
    layersToRemoveIds.forEach((layerId) => {
      if (styleLayerIds.includes(layerId)) {
        map.removeLayer(layerId);
      }
    });
  })();
};

const LAYERS_UNIQUE_ID_LENGTH = 8;
/**
 * Returns postfix string of format `[uniqueId]` or `[mapStyleId]_[uniqueId]` to be used in unique layer id construction
 * @param mapStyleId id of a currently used map style, e.g. streets/satellite/hybrid etc.
 * @returns postfix: `string`
 */
export const getLayersIdUniquePostfix = (mapStyleId?: string) => {
  const id = nanoid(LAYERS_UNIQUE_ID_LENGTH);
  return mapStyleId ? `${mapStyleId}_${id}` : id;
};

/**
 * Creates getter function for `baseLayerId` which provides layer id based on the `postfix` parameter
 * @param baseLayerId base part of the layer id
 * @returns `(postfix: string) => string`
 */
export const createGetLayerIdWithPostfix =
  (baseLayerId: string) =>
  (postfix = ''): string =>
    baseLayerId + (postfix ? `_${postfix}` : '');
